import { Component, input, output } from '@angular/core';
import { RidKlankCard } from '../rid-klank-card/rid-klank-card';

@Component({
  selector: 'rid-klank-card-clickable',
  imports: [RidKlankCard],
  templateUrl: './rid-klank-card-clickable.html',
})
export class RidKlankCardClickable {
  klank = input.required<string>();
  disabled = input<boolean>();

  clicked = output<void>();
}
